import React from "react";
import { ElementComponentProps } from "elements/types";
import { TextInputElement } from "records/Element";
import TextInputMultiContainer from "./TextInputMultiContainer";
import TextInputSingleContainer from "./TextInputSingleContainer";

function TextInputContainer({
	isArray,
	limit,
	...rest
}: ElementComponentProps<TextInputElement>) {
	return isArray ? (
		<TextInputMultiContainer {...rest} limit={limit} />
	) : (
		<TextInputSingleContainer {...rest} />
	);
}

export default React.memo(TextInputContainer);
